webpackJsonp([35783957827783],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/matt-turnbull-cartoon-240.f53e0f3e.png";

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ContentListing = __webpack_require__(79);
	
	var _ContentListing2 = _interopRequireDefault(_ContentListing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ContentListing2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _mattTurnbullCartoon = __webpack_require__(136);
	
	var _mattTurnbullCartoon2 = _interopRequireDefault(_mattTurnbullCartoon);
	
	var _mattTurnbullCartoon3 = __webpack_require__(137);
	
	var _mattTurnbullCartoon4 = _interopRequireDefault(_mattTurnbullCartoon3);
	
	var _Link = __webpack_require__(6);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaceLink = function FaceLink(_ref) {
		var _ref$size = _ref.size,
		    size = _ref$size === undefined ? 120 : _ref$size;
		return React.createElement(
			_Link2.default,
			{ to: "/about/" },
			React.createElement("img", {
				src: _mattTurnbullCartoon2.default,
				srcSet: _mattTurnbullCartoon4.default + " 2x",
				alt: "Matt Turnbull",
				width: size,
				height: size,
				className: (0, _classnames2.default)("block rounded-full", "border-2 border-turtle-darker", "hover:grow-sm transition-slow")
			})
		);
	};
	
	exports.default = FaceLink;
	module.exports = exports["default"];

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _FaceLink = __webpack_require__(85);
	
	var _FaceLink2 = _interopRequireDefault(_FaceLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FaceLink2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _ArrowRight = __webpack_require__(34);
	
	var _ArrowRight2 = _interopRequireDefault(_ArrowRight);
	
	var _FaceLink = __webpack_require__(86);
	
	var _FaceLink2 = _interopRequireDefault(_FaceLink);
	
	var _Link = __webpack_require__(6);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Hey = function Hey() {
		return React.createElement(
			"div",
			{ className: "text-center" },
			React.createElement(
				"div",
				{ className: "inline-flex flex-col sm:flex-row items-center" },
				React.createElement(
					"div",
					{ className: "pb-4 sm:pb-0 sm:pr-8" },
					React.createElement(_FaceLink2.default, null)
				),
				React.createElement(
					"div",
					null,
					React.createElement(Info, null)
				)
			)
		);
	};
	
	var Info = function Info() {
		return React.createElement(
			"div",
			{ className: "flex flex-col" },
			React.createElement(
				"div",
				{ className: "text-center pb-4" },
				React.createElement(
					"h1",
					{ className: "text-lg" },
					"Hey, I\u2019m",
					" ",
					React.createElement(
						_Link2.default,
						{ to: "/about/", className: "link-border" },
						"Matt Turnbull"
					)
				),
				React.createElement(
					"div",
					{ className: "mt-4" },
					"I make websites & apps."
				)
			),
			React.createElement(
				"div",
				{ className: "self-end" },
				React.createElement(InfoLink, null)
			)
		);
	};
	
	var InfoLink = function InfoLink() {
		return React.createElement(
			_Link2.default,
			{ to: "/about/", className: "flex items-center link-border border-dashed" },
			React.createElement(_ArrowRight2.default, { className: "w-4 h-4 mr-1" }),
			React.createElement(
				"div",
				null,
				"More"
			)
		);
	};
	
	exports.default = Hey;
	module.exports = exports["default"];

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Hey = __webpack_require__(253);
	
	var _Hey2 = _interopRequireDefault(_Hey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Hey2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _ContentListing = __webpack_require__(80);
	
	var _ContentListing2 = _interopRequireDefault(_ContentListing);
	
	var _HeadTags = __webpack_require__(87);
	
	var _HeadTags2 = _interopRequireDefault(_HeadTags);
	
	var _Hey = __webpack_require__(254);
	
	var _Hey2 = _interopRequireDefault(_Hey);
	
	var _PageContainer = __webpack_require__(11);
	
	var _PageContainer2 = _interopRequireDefault(_PageContainer);
	
	var _PitchIntroContainer = __webpack_require__(89);
	
	var _PitchIntroContainer2 = _interopRequireDefault(_PitchIntroContainer);
	
	var _headTags = __webpack_require__(92);
	
	var _headTags2 = _interopRequireDefault(_headTags);
	
	var _result = __webpack_require__(93);
	
	var _url = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	var PageIndex = function PageIndex(_ref) {
		var contentListResult = _ref.data.contentListResult,
		    pathname = _ref.location.pathname;
		return React.createElement(
			"div",
			null,
			React.createElement(_HeadTags2.default, (0, _headTags2.default)({
				pageUrl: (0, _url.prefixSiteUrl)(pathname),
				pageTitle: "I Am Turns"
			})),
			React.createElement(
				_PageContainer2.default,
				{ className: "pt-16" },
				React.createElement(_Hey2.default, null)
			),
			React.createElement(_ContentListing2.default, { contentList: (0, _result.getResultAsArray)(contentListResult), className: "pt-16" }),
			React.createElement(_PitchIntroContainer2.default, null)
		);
	};
	
	exports.default = PageIndex;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-11aa8e856ac29b17b893.js